/**
 * Carga condicional de Google Analytics (gtag.js) — Ley 21.719.
 *
 * Solo inyecta el script si el usuario otorgó consentimiento "analiticas".
 * Si revocan, deshabilita el envío y borra cookies _ga/_gid del dominio.
 *
 * Property: G-SXBBK8BQJR
 */
import { useEffect, useRef } from "react";
import { getConsent, subscribe } from "@/lib/cookieConsent";

const GA_ID = "G-SXBBK8BQJR";

function loadGoogleAnalytics() {
  if (typeof window === "undefined") return;
  if (document.getElementById("ga-script")) return; // ya cargado

  // Stub gtag antes del script para no perder eventos disparados muy temprano
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    anonymize_ip: true, // anonimización IP, alineado con la política
    send_page_view: true,
  });

  const s = document.createElement("script");
  s.id = "ga-script";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

function unloadGoogleAnalytics() {
  if (typeof window === "undefined") return;
  try {
    // Bloquea futuros envíos
    window[`ga-disable-${GA_ID}`] = true;
  } catch {
    // ignore
  }
  // Borrar cookies _ga, _ga_*, _gid del dominio actual y .root domain
  try {
    const cookies = document.cookie.split(";");
    const host = window.location.hostname;
    const rootDomain = host.split(".").slice(-2).join(".");
    cookies.forEach((c) => {
      const name = c.split("=")[0].trim();
      if (name.startsWith("_ga") || name === "_gid" || name === "_gat") {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${host}`;
        document.cookie = `${name}=; Max-Age=0; path=/; domain=.${rootDomain}`;
        document.cookie = `${name}=; Max-Age=0; path=/`;
      }
    });
  } catch {
    // ignore
  }
}

export default function GoogleAnalyticsLoader() {
  const loadedRef = useRef(false);

  useEffect(() => {
    const apply = (consent) => {
      const allow = !!consent?.analiticas;
      if (allow && !loadedRef.current) {
        loadGoogleAnalytics();
        loadedRef.current = true;
      } else if (!allow && loadedRef.current) {
        unloadGoogleAnalytics();
        loadedRef.current = false;
      }
    };
    apply(getConsent());
    const unsub = subscribe(apply);
    return () => unsub();
  }, []);

  return null;
}
